import React, { Component } from 'react';
import store from 'store';
import StoreGetters from 'store/store-getters';
import { STATE } from 'services/3dviewer/moving-controls/synchronizeController';
import { VIEW } from '../config';
import * as THREE from 'three';

import './css/roomtypetag.scss';

export default class RoomTag extends Component {
  constructor() {
    super();
    this.state = {
      // [Note]: 站點名稱未完整呈現 (RoomTag 位置與大小修改)
      style: { bottom: '50%', right: '50%', width: 'initial', height: 'initial', fontSize: 'samll' },
      isLabelShow: true,
      isShow: true,
    };

    this.roomtype = '';
    this.floorIndex = -1;

    // [Note]: 站點名稱未完整呈現 (RoomTag 位置與大小修改)
    this.curSize = React.createRef();
    this.setDefaultSize = false;
    this.curWidth = 0;
    this.curHeight = 0;

    this.onClick = () => {};

    // 新增：raycaster 用於檢測 hotspot 是否可點擊
    this.raycaster = new THREE.Raycaster();
  }

  // 新增：檢測 hotspot 是否真的可以被點擊到
  isHotspotClickable = (hotspot, scene) => {
    try {
      const { viewerCameraController } = scene;
      const { camera } = viewerCameraController;

      // 獲取當前攝影機位置
      const cameraPosition = new THREE.Vector3();
      camera.getWorldPosition(cameraPosition);

      // 獲取 hotspot 的世界座標
      const hotspotPosition = new THREE.Vector3();
      hotspot.mesh.getWorldPosition(hotspotPosition);

      // 計算從攝影機到 hotspot 的方向向量
      const direction = new THREE.Vector3()
        .subVectors(hotspotPosition, cameraPosition)
        .normalize();

      // 設置 raycaster
      this.raycaster.set(cameraPosition, direction);

      // 獲取所有房間和門的 mesh 進行檢測
      const { building, currentRenderIndex } = store.getState();
      let allRoomMeshArray = [];
      let allDoorMeshArray = [];

      if (currentRenderIndex !== -1 && building.floorList[currentRenderIndex]) {
        // 從當前樓層獲取所有房間和門的 mesh
        const currentFloor = building.floorList[currentRenderIndex];
        if (currentFloor.objManager) {
          const objManagerData = currentFloor.objManager.getAll();
          allRoomMeshArray = objManagerData.allRoomsMeshArray || [];
          allDoorMeshArray = objManagerData.allDoorsMeshArray || [];
        }
      }

      // 如果無法獲取 mesh 陣列，嘗試從 scene 中獲取
      if (allRoomMeshArray.length === 0 && scene.currentSceneInfo) {
        const { rooms, doors } = scene.currentSceneInfo;
        if (rooms) {
          allRoomMeshArray = Object.values(rooms).map(room => room.mesh);
        }
        if (doors) {
          allDoorMeshArray = Object.values(doors).map(door => door.mesh);
        }
      }

      // 合併所有需要檢測的物件
      const intersectObjects = allRoomMeshArray.concat(allDoorMeshArray);

      // 如果沒有物件可以檢測，預設為可點擊
      if (intersectObjects.length === 0) {
        return true;
      }

      // 執行 raycast
      const intersects = this.raycaster.intersectObjects(
        intersectObjects,
        true
      );

      if (intersects.length > 0) {
        // 檢查所有碰撞的物件，跳過透明的門
        for (let i = 0; i < intersects.length; i++) {
          const intersect = intersects[i];

          // 如果碰撞的是 hotspot，則可以點擊
          if (intersect.object.objectType === 'hotspot') {
            return true;
          }

          // 如果碰撞的是門，則跳過（門是透明的）
          if (intersect.object.objectType === 'door') {
            continue;
          }

          // 如果碰撞的是房間（牆壁），則檢查是否阻擋了 hotspot
          if (intersect.object.objectType === 'room') {
            const distanceToHotspot = cameraPosition.distanceTo(
              hotspotPosition
            );
            const distanceToObstacle = intersect.distance;

            // 如果障礙物比 hotspot 更遠，則 hotspot 可以被點擊
            // 添加一個小的容差值，避免浮點數精度問題
            const tolerance = 0.1;
            return distanceToObstacle >= distanceToHotspot - tolerance;
          }
        }

        // 如果所有碰撞的物件都是門，則 hotspot 可以被點擊
        return true;
      }

      // 如果沒有碰撞，則 hotspot 可以被點擊
      return true;
    } catch (error) {
      console.warn('檢測 hotspot 可點擊性時發生錯誤:', error);
      // 如果檢測失敗，預設為可點擊
      return true;
    }
  };

  componentDidMount() {
    const { room } = this.props;
    const { mainRoomId, mesh } = room;

    const { building } = store.getState();

    search: for (let index in building.floorList) {
      try {
        const { hierarchy } = building.floorList[index];
        for (let i = 0; i < hierarchy.length; i++) {
          const roomDict = hierarchy[i];
          if (roomDict.panoramas[mainRoomId]) {
            this.roomtype = roomDict.panoramas[mainRoomId].info.type;
            if (this.roomtype) {
              this.floorIndex = parseInt(index);
              break search;
            }
          }
        }
      } catch (e) {
        console.warn(e);
        continue;
      }
    }
    
    this.setVisible();
    mesh.onAfterRender = this.setPos;

    this.onClick = () => {
      const { viewButton } = store.getState();
      const { goDependOnState } = viewButton;
      goDependOnState(mainRoomId);
    };

    this.unsubscribe = store.subscribe(this.setVisible);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.mode !== this.props.mode) {
      this.setVisible();
    }
  }

  setPos = () => {
    // [Note]: 站點名稱未完整呈現 (RoomTag 位置與大小修改)
    if(!this.setDefaultSize) {
      this.setDefaultSize = true;
      if(this.curSize.current != null) {
        this.curWidth = this.curSize.current.offsetWidth
        this.curHeight = this.curSize.current.offsetHeight
      }
      else {
        this.curWidth = 65
        this.curHeight = 30
      }
    }
    // [Note]: 站點名稱未完全呈現
    const { viewButton } = store.getState();
    const { viewState } = viewButton;
    const {hotspot} = this.props;
    
    const { room, isMain, mode, type, scene } = this.props;

    // 新增：檢測 hotspot 是否真的可以被點擊到（只在 FPVIEW 模式下）
    if (viewState == STATE.FPVIEW) {
      const isClickable = this.isHotspotClickable(hotspot, scene);
      if (!isClickable) {
        this.hide();
        return;
      }
    }

    let scale = 50;
    let offset = 50;
    switch (mode) {
      case VIEW.SINGLE:
        if (isMain) {
          scale = 100;
          offset = 0;
        } else {
          // this.hide();
        }
        break;
      case VIEW.DOUBLE:
        if (isMain) {
          scale = 50;
          offset = 50;
        } else {
          scale = 50;
          offset = 0;
        }
        break;
      case VIEW.RIGHTFULL:
        if (isMain) {
          // this.hide();
        } else {
          scale = 100;
          offset = 0;
        }
        break;
    }

    // [Note]: 站點名稱未完全呈現
    // const screenCoordinate = room.getTagScreenPosition(
    //   scene.viewerCameraController
    // );
    // [Note]: 站點名稱未完整呈現 (RoomTag 位置與大小修改)
    let tagWidth
    let tagHeight
    let tagFontSize
    let screenCoordinate;
    if(viewState == STATE.FPVIEW) {
      screenCoordinate= room.getTagScreenPositionFPVIEW(
        scene.viewerCameraController,
        hotspot
      );
      // [Note]: 站點名稱未完整呈現 (RoomTag 位置與大小修改)
      // [Note]: Version 1
      tagWidth = this.curWidth + 10
      tagHeight = this.curHeight + 10
      // [Note]: Version 2
      // tagWidth = 55
      // tagHeight = 40
      tagFontSize = 'medium'
    } 
    else {
      screenCoordinate= room.getTagScreenPosition(
        scene.viewerCameraController,
        hotspot
      );
      // [Note]: 站點名稱未完整呈現 (RoomTag 位置與大小修改)
      tagWidth = this.curWidth
      tagHeight = this.curHeight
      tagFontSize = 'small'
    }

    if (
      screenCoordinate.x > 0 &&
      screenCoordinate.x < 1 &&
      screenCoordinate.y > 0 &&
      screenCoordinate.y < 1 &&
      screenCoordinate.z < 1.0 &&
      screenCoordinate.z > -1.0
    ) {
      if (this.state.isLabelShow) this.show();

      if (type === 'PC') {
        const screenX = (1 - screenCoordinate.x) * scale + offset;
        const screenY = (1 - screenCoordinate.y) * 100;
        // this.updatePosition(screenX, screenY);
        // [Note]: 站點名稱未完整呈現 (RoomTag 位置與大小修改)
        this.updateTransform(screenX, screenY, tagWidth, tagHeight, tagFontSize);
      } else {
        const screenX = (1 - screenCoordinate.x) * 100;
        const screenY = (1 - screenCoordinate.y) * scale + offset;
        // this.updatePosition(screenX, screenY);
        // [Note]: 站點名稱未完整呈現 (RoomTag 位置與大小修改)
        this.updateTransform(screenX, screenY, tagWidth, tagHeight, tagFontSize);
      }
      return;
    }

    this.hide();
  };

  setVisible = () => {
    const { viewButton, currentRenderIndex } = store.getState();
    const { viewState } = viewButton;
    const { room, hotspot, scene } = this.props;

    const { building, currentHotSpot } = store.getState();
      // [Note]: 站點名稱未完全呈現
    if (currentRenderIndex == -1 || currentRenderIndex == this.floorIndex) {
      if(viewState != STATE.FPVIEW) {    
        room.tagVisible = true;
        this.labelShow(true);
        this.show(); 
      }
      else {
        // 新增：在 FPVIEW 模式下檢測 hotspot 是否可點擊
        const isClickable = this.isHotspotClickable(hotspot, scene);
        if (!isClickable) {
          room.tagVisible = false;
          this.labelShow(false);
          this.hide();
          return;
        }

        // [Note]: visible tags
        let roomPano = building.floorList[currentRenderIndex].hierarchy[0].panoramas[currentHotSpot]
  
        if(roomPano != null) {
          if(roomPano.hasOwnProperty("visibleTags")) {
            const currentVisibleTags = Object.values(roomPano.visibleTags)
          
            if(currentVisibleTags.indexOf(room.textName) != -1) {
              room.tagVisible = false;  // [Note]: hide tagline
              this.labelShow(true);
              this.show();
            }
            else {
              room.tagVisible = false;
              this.labelShow(false);
              this.hide();  
            }
          }
          else {  // [Note]: 沒有設定 "visibleTags" 的測資 => defualt秀出所有tag
            room.tagVisible = false;   // [Note]: hide tagline
            this.labelShow(true);
            this.show();
          }
        }
        // [Note]: 所在站點不應該出現空間名稱
        // [Note]: 只有"左"場景都會隱藏當前站點的roomtag
        if(room.mainRoomId == currentHotSpot) { 
          room.tagVisible = false;
          this.labelShow(false);
          this.hide();
        }
        // [Note]: "左右"場景都會隱藏當前站點的roomtag
        // if(roomPano != null) {
        //   if(room.textName == roomPano.info.type) {
        //     room.tagVisible = false;
        //     this.labelShow(false);
        //     this.hide();
        //   }  
        // }
      }
    }
    else {
      room.tagVisible = false;
      this.labelShow(false);
      this.hide(); 
    }   
  };

  componentWillUnmount() {
    this.unsubscribe();
  }

  updatePosition = (left, top) => {
    this.setState({
      style: { right: `${left.toString()}%`, bottom: `${top.toString()}%` },
    });
  };
  // [Note]: 站點名稱未完整呈現 (RoomTag 位置與大小修改)
  updateTransform = (left, top, width, height, fontSize) => {
    this.setState({
      style: { right: `${left.toString()}%`, bottom: `${top.toString()}%`, width: `${width.toString()}px`, height: `${height.toString()}px`, fontSize: fontSize },
    });
  };

  labelShow(status) {
    this.setState({
      isLabelShow: status,
    });
  }

  show() {
    this.setState({
      isShow: true,
    });
  }

  hide() {
    this.setState({
      isShow: false,
    });
  }

  render() {
    return (
      <>
        {this.state.isShow == true && (
          <button
            className="roomTag"
            style={this.state.style}
            ref={this.curSize}  // [Note]: 站點名稱未完整呈現 (RoomTag 位置與大小修改)
            onClick={this.onClick}
          >
            {this.roomtype}
          </button>
        )}
      </>
    );
  }
}
